import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-news-banner-category-card',
  templateUrl: './news-banner-category-card.component.html',
  styleUrl: './news-banner-category-card.component.scss',
  standalone: false,
})
export class NewsBannerCategoryCardComponent {
  @Input() colorHead: string = '#1C665B';
  @Input() colorShapes: string = '#1C665B';
  @Input() backgroundColor: string = '#D2E0DE';
}
